export default __webpack_public_path__ + "static/media/050-cookie & milk.42843910.svg";